import { render, staticRenderFns } from "./InsurerSelector.vue?vue&type=template&id=663d2636&scoped=true"
import script from "./InsurerSelector.vue?vue&type=script&lang=js"
export * from "./InsurerSelector.vue?vue&type=script&lang=js"
import "./InsurerSelector.vue?vue&type=style&index=0&id=663d2636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d2636",
  null
  
)

export default component.exports